export class Phone {
  id: number;
  model: string;
  imei1: string;
  imei2: string;
  serialNumber: string;
  trackingNumber: string;
  customerFullName: string;
  phoneNumber: string;
  mail: string;
  paymentStatus: boolean;
  status: string;
  createdAt: Date;
  updatedAt: Date;
}
